export interface Correlation {
  relatedServiceId: string;
  confidenceLb: number;
}

// Mirrors the API's Correlation::ServiceSuggester: each related service keeps
// its five strongest anchors, and their lower bounds combine with noisy-OR so
// several anchors pointing at the same gap rank it higher.
const MAX_ANCHORS_PER_TARGET = 5;

const rankSuggestions = (
  correlations: Correlation[],
  excludeIds: string[],
  limit: number
): string[] => {
  const excluded = new Set(excludeIds);
  const byTarget = new Map<string, number[]>();
  correlations.forEach(({ relatedServiceId, confidenceLb }) => {
    if (excluded.has(relatedServiceId)) return;
    byTarget.set(relatedServiceId, [
      ...(byTarget.get(relatedServiceId) || []),
      confidenceLb,
    ]);
  });

  // Array.from, not spread: the app's loose Babel build turns [...iterator]
  // into [].concat(iterator), which wraps the iterator instead of draining it.
  return Array.from(byTarget.entries())
    .map(([id, scores]) => ({
      id,
      score:
        1 -
        scores
          .sort((a, b) => b - a)
          .slice(0, MAX_ANCHORS_PER_TARGET)
          .reduce((acc, score) => acc * (1 - score), 1),
    }))
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map(({ id }) => id);
};

export default rankSuggestions;
